'use client';

import React, { useState, useEffect } from 'react';
import { RefreshCw } from 'lucide-react';
import { useTeam } from '@/context/TeamContext';

const TEAM_SUBTITLES: Record<string, string> = {
  education:   'Studio lessons, instructor schedule, and student coverage for today.',
  production:  'Live events, gig logistics, and performance readiness for today.',
  development: 'Outreach meetings, grant follow-ups, and funder activity for today.',
  leadership:  'Cross-team overview — all branches, gaps, and decisions for today.',
};

export default function TodayHeader() {
  const { activeTeam } = useTeam();
  const [dayName, setDayName] = useState('');
  const [dateStr, setDateStr] = useState('');

  useEffect(() => {
    const today = new Date('2026-04-07');
    setDayName(today.toLocaleDateString('en-US', { weekday: 'long' }));
    setDateStr(today.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }));
  }, []);

  return (
    <div className="flex items-start justify-between">
      <div>
        <p className="text-[12px] font-medium text-slate-400 uppercase tracking-widest mb-1">{dayName}</p>
        <div className="flex items-center gap-3">
          <h1 className="text-2xl font-semibold text-slate-800">{dateStr}</h1>
          <span className={`text-[11px] font-bold px-2.5 py-1 rounded-full ${activeTeam.accentBg} ${activeTeam.color}`}>
            {activeTeam.label}
          </span>
        </div>
        <p className="text-[13px] text-slate-400 mt-1">
          {TEAM_SUBTITLES[activeTeam.id]}
        </p>
      </div>
      <div className="flex items-center gap-2 mt-1">
        <div className="flex items-center gap-1.5 text-[11px] text-slate-400">
          <RefreshCw size={11} />
          <span className="font-mono">Synced 7:48 AM</span>
        </div>
      </div>
    </div>
  );
}